import { render } from "./StandardSelect.vue?vue&type=template&id=bf11d9fe&scoped=true"
import script from "./StandardSelect.vue?vue&type=script&lang=js"
export * from "./StandardSelect.vue?vue&type=script&lang=js"

import "./StandardSelect.vue?vue&type=style&index=0&id=bf11d9fe&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf11d9fe"]])

export default __exports__